export function difference(item) {
    const c = item.price - item.discountedPrice
    return c
}